import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";

import { useZohoAuth } from "../hook/useZohoAuth";
import { SignatureTab } from "../components/organisms/SignatureTab";
import { zohoApi } from "../zohoApi";

const MAXWIDTH = "80rem";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export function SettingsRoute() {
  const {
    authLoadingZoho,
    zohoAuthenticated,
    handleRevokeAuth,
    handleGrantAuth,
    configdata,
    orgId,
    apiKey,
    dataCenterUrl,
    accessToken,
  } = useZohoAuth({ checkZohoAuth: true });

  const [tabIndex, setTabIndex] = React.useState(0);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          aria-label="tabs"
          sx={{ overflowX: "auto" }}
          //---------
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          //---------
        >
          <Tab
            label="Authentication"
            sx={{ textTransform: "capitalize" }}
            {...a11yProps(0)}
          />
          <Tab
            label="Settings"
            disabled={!zohoAuthenticated || authLoadingZoho}
            sx={{ textTransform: "capitalize" }}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={tabIndex} index={0}>
        <Box sx={{ p: "12px 16px" }}>
          <Box
            sx={{
              p: "2em",
              borderRadius: "8px",
              maxWidth: MAXWIDTH,
              // margin: "0 auto",
            }}
          >
            <Typography
              sx={{
                mb: "1em",
                color: "rgba(32,33,35,.9)",
                fontWeight: 700,
              }}
            >
              Authenticate ZOHO CRM and Writer Services for API Access
            </Typography>
            <Typography
              sx={{
                color: "rgba(32,33,35,.39)",
                fontSize: "14px",
                mb: "1.5em",
              }}
            >
              To effectively utilize the Zoho CRM REST API for sending emails or
              performing other actions, you'll need to authenticate your
              application with Zoho. This ensures secure access to your CRM and
              Writer data and enables the API to perform tasks on your behalf.
            </Typography>
            {zohoAuthenticated ? (
              <Button
                onClick={handleRevokeAuth}
                variant="contained"
                sx={{
                  textTransform: "capitalize",
                  width: "180px",
                  "-webkit-justify-content": "left",
                  justifyContent: "left",
                }}
              >
                {authLoadingZoho ? "Loading..." : "Revoke"}
              </Button>
            ) : (
              <Button
                onClick={handleGrantAuth}
                variant="contained"
                sx={{
                  textTransform: "capitalize",
                  width: "180px",
                  "-webkit-justify-content": "left",
                  justifyContent: "left",
                }}
              >
                {authLoadingZoho ? "Loading..." : "Authenticate"}
              </Button>
            )}
          </Box>
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={tabIndex} index={1}>
        <Box sx={{ p: "12px 16px" }}>
          <Box
            sx={{
              p: "2em",
              borderRadius: "8px",
              maxWidth: MAXWIDTH,
              textAlign: "right",
            }}
          >
            <SignatureTab
              configdata={configdata}
              orgId={orgId}
              apiKey={apiKey}
              dataCenterUrl={dataCenterUrl}
              accessToken={accessToken}
            />
          </Box>
        </Box>
      </CustomTabPanel>
    </Box>
  );
}
